import React, { useEffect, useState } from 'react';

import { Wrapper, Col1, Title, SubTitle } from './../OpeningHours/style';

import { FormControl, TextField, MenuItem, Box } from '@material-ui/core';
import { useFormik } from 'formik';
import { LogisticalLevel } from './LogisticalLevel/LogisticalLevel';
import { Button, LogisticsIntegration } from './LogisticsIntegration/LogisticsIntegration';
import {
  Card,
  FormContainer,
  FormDiv,
  FormLabel,
  FormLabelControl,
  FormlLabelPartial,
  FormPartialDiv,
  IOSSwitch,
  UnavailableDeliveryTypeMessage,
} from './style';
import { api } from '../../redux/store';
import withAuthHeader from '../../utils/withAuthHeader';
import {
  makePayoadPostSettingPlatform,
  mapSettingsPlatform,
} from '../../redux/mappers/settings-platform';
import { LoadingOverlay } from '../../components/common';
import { useDispatch } from 'react-redux';
import { showNotification } from '../../redux/actions/ui';
import { Prompt } from 'react-router-dom';

const baseURL = 'api/v1/dashboard/estabelecimentos/configuracoesdelivery';

const formikInitialValues = {
  deliveryRadius: '',
  deliveryMinTime: '',
  deliveryMaxTime: '',
  cookingTimeStatus: false,
  cookingTimeValue: '',
  freeDeliveryStatus: false,
  freeDeliveryMinValue: '',
  freeDeliveryMaxDistance: '',
  deliveryType: 'default$',
  logisticalLevelUntil: '',
  logisticalLevelValue: '',
  platform: 'default$',
  integrationKey: '',
  deliveryTaxCalc: false,
  callDeliveryman: false,
  security: false,
  callDeliverymanManually: false,
};

const selectDeliveryTypeList = [
  {
    label: 'Patamar logístico',
    value: 1,
    available: true,
  },
  {
    label: 'Integração de logística terceirizada',
    value: 2,
    available: true,
  },
  {
    label: 'Mapa Polígono',
    value: 3,
  },
  {
    label: 'Nenhum',
    value: 4,
    available: true,
  },
  {
    label: 'Integração Terceirizada com Mapa Polígono',
    value: 5,
  },
  {
    label: 'Por Distância e Integração Logística',
    value: 6,
  },
  {
    label: 'Integração JC Garcia',
    value: 7,
  },
  {
    label: 'Patamares de Entrega com Integração Terceirizada',
    value: 8,
  },
];

const getDeliveryTypeAvailability = (deliveryTypeId) =>
  !!selectDeliveryTypeList.find(({ value, available }) => available && deliveryTypeId === value);

export const SettingsComponent = ({ storeId }) => {
  const dispatch = useDispatch();

  const [logisticalLevels, setLogisticalLevels] = useState([]);
  const [deliveryPlatform, setDeliveryPlatform] = useState([]);
  const [loading, setLoading] = useState(true);
  const [initialValues, setInitialValues] = useState(undefined);
  const [saveState, setSaveState] = useState(false);
  const [selectedDeliveryTypeAvailable, setSelectedDeliveryTypeAvailable] = useState(true);

  const getStoreConfigs = () => {
    setLoading(true);
    api
      .get(baseURL, {
        ...withAuthHeader(),
        params: storeId ? { EstabelecimentoId: storeId } : {},
      })
      .then(({ data }) => {
        const mappedSettings = mapSettingsPlatform(data);
        setInitialValues(mappedSettings);
        formik.setValues({ ...formikInitialValues, ...mappedSettings });

        if (data.ModeloTaxaId) {
          setSelectedDeliveryTypeAvailable(getDeliveryTypeAvailability(data.ModeloTaxaId));
        }

        setDeliveryPlatform(mappedSettings.deliveryPlatform);
        setLogisticalLevels(mappedSettings.logisticalLevel);
      })
      .catch(() => {
        dispatch(
          showNotification({
            type: 'error',
            text: 'Erro ao buscar configurações da plataforma',
          })
        );
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const postStoreConfigs = (newValue, changeState = true) => {
    setLoading(true);
    api
      .post(
        baseURL,
        {
          ...makePayoadPostSettingPlatform({
            ...newValue,
            selectedDeliveryTypeAvailable,
          }),
        },
        {
          ...withAuthHeader(),
          params: storeId ? { EstabelecimentoId: storeId } : {},
        }
      )
      .then(() => {
        if (changeState) setSaveState(false);
        getStoreConfigs();
        dispatch(
          showNotification({
            type: 'success',
            text: 'Configuração salva com sucesso',
          })
        );
      })
      .catch(() => {
        dispatch(
          showNotification({
            type: 'error',
            text: 'Erro ao editar configurações da plataforma',
          })
        );
        setLoading(false);
      });
  };

  const onSubmit = (values) => {
    if (
      values.deliveryRadius !== undefined &&
      values.deliveryRadius !== '' &&
      values.deliveryMaxTime !== undefined &&
      values.deliveryMaxTime !== '' &&
      values.deliveryMinTime !== undefined &&
      values.deliveryMinTime !== '' &&
      (values.cookingTimeStatus
        ? values.cookingTimeValue !== undefined && values.cookingTimeValue !== ''
        : true) &&
      (values.freeDeliveryStatus
        ? values.freeDeliveryMinValue !== undefined &&
          values.freeDeliveryMinValue !== '' &&
          values.freeDeliveryMaxDistance !== undefined &&
          values.freeDeliveryMaxDistance !== ''
        : true)
    ) {
      postStoreConfigs(
        {
          ...initialValues,
          ...values,
        },
        false
      );
    }
  };

  const onChangePlatformPriority = (priorities) => {
    setSaveState(true);
    setInitialValues({
      ...initialValues,
      deliveryPlatform: priorities,
      logisticalLevel: [],
      deliveryType: formik.values.deliveryType,
    });
  };

  const onAddLogisticalLevel = (newValue) => {
    setSaveState(true);
    setInitialValues({
      ...initialValues,
      logisticalLevel: [
        ...initialValues.logisticalLevel,
        {
          radius: newValue.logisticalLevelUntil,
          value: Number(newValue.logisticalLevelValue.toString().replace(',', '.')),
        },
      ],
      deliveryPlatform: [],
      deliveryType: formik.values.deliveryType,
    });
  };

  const onAddLogistialIntegration = (newValue) => {
    setSaveState(true);
    setInitialValues({
      ...initialValues,
      deliveryPlatform: [...deliveryPlatform, newValue],
      logisticalLevel: [],
      deliveryType: formik.values.deliveryType,
    });
  };

  const onEditLogisticalLevel = (newValue) => {
    setSaveState(true);
    setInitialValues({
      ...initialValues,
      logisticalLevel: newValue,
      deliveryPlatform: [],
      deliveryType: formik.values.deliveryType,
    });
  };

  const onEditLogisticsIntegration = (newValue) => {
    setSaveState(true);
    setInitialValues({
      ...initialValues,
      deliveryPlatform: newValue,
      logisticalLevel: [],
      deliveryType: formik.values.deliveryType,
    });
  };

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: formikInitialValues,
    onSubmit,
  });

  useEffect(() => {
    getStoreConfigs();
  }, []);

  useEffect(() => {
    const deliveryType = formik.getFieldProps('deliveryType').value;

    setInitialValues({
      ...initialValues,
      deliveryType: deliveryType,
    });
    setSelectedDeliveryTypeAvailable(getDeliveryTypeAvailability(deliveryType));
  }, [formik.getFieldProps('deliveryType').value]);

  useEffect(() => {
    getStoreConfigs();
  }, [storeId]);

  useEffect(() => {
    setDeliveryPlatform(initialValues?.deliveryPlatform);
  }, [initialValues?.deliveryPlatform]);

  useEffect(() => {
    setLogisticalLevels(initialValues?.logisticalLevel);
  }, [initialValues?.logisticalLevel]);

  const getDeliveryComponent = () => {
    switch (formik.values.deliveryType) {
      case 1:
        return (
          <LogisticalLevel
            formik={formik}
            logisticalLevels={logisticalLevels}
            onAddLogisticalLevel={onAddLogisticalLevel}
            onEditLogisticalLevel={onEditLogisticalLevel}
          />
        );
      case 2:
        return (
          <LogisticsIntegration
            formik={formik}
            deliveryPlatform={deliveryPlatform}
            onChangePlatformPriority={onChangePlatformPriority}
            onAddLogistialIntegration={onAddLogistialIntegration}
            onEditLogisticsIntegration={onEditLogisticsIntegration}
          />
        );
      default:
        return <></>;
    }
  };

  return (
    <>
      <Prompt
        when={saveState}
        message="Você possui alterações não salvas. Deseja mesmo sair da página?"
      />
      <Wrapper>
        <LoadingOverlay visible={loading} />
        <Col1>
          <Title>Configuração plataforma delivery </Title>
          <Card>
            <SubTitle>Configurações gerais</SubTitle>

            <form style={{ marginTop: 16 }} width="100%">
              <FormDiv>
                <FormControl>
                  <FormLabel>Raio de entrega (Km)</FormLabel>
                  <TextField
                    style={{ width: 250 }}
                    InputProps={{ inputProps: { min: 0 } }}
                    required
                    variant="outlined"
                    placeholder="Ex: 10"
                    size="small"
                    min
                    type="number"
                    {...formik.getFieldProps('deliveryRadius')}
                  />
                </FormControl>
                <FormControl>
                  <FormLabel>Tempo de entrega (min)</FormLabel>
                  <div style={{ display: 'flex' }}>
                    <FormPartialDiv mr="18px">
                      <FormlLabelPartial style={{ marginRight: '6px !important' }}>
                        Min:
                      </FormlLabelPartial>
                      <TextField
                        style={{ width: 100 }}
                        InputProps={{ inputProps: { min: 0 } }}
                        required
                        variant="outlined"
                        placeholder="Ex: 0"
                        size="small"
                        type="number"
                        {...formik.getFieldProps('deliveryMinTime')}
                      />
                    </FormPartialDiv>
                    <FormPartialDiv>
                      <FormlLabelPartial style={{ marginRight: '6px !important' }}>
                        Max:
                      </FormlLabelPartial>
                      <TextField
                        style={{ width: 100 }}
                        InputProps={{ inputProps: { min: 0 } }}
                        required
                        variant="outlined"
                        placeholder="Ex: 15"
                        size="small"
                        type="number"
                        {...formik.getFieldProps('deliveryMaxTime')}
                      />
                    </FormPartialDiv>
                  </div>
                </FormControl>
              </FormDiv>

              <FormContainer>
                <FormControl>
                  <FormLabel>Tempo de preparo (min)</FormLabel>
                  <FormLabelControl
                    style={{ marginLeft: 8 }}
                    control={<IOSSwitch sx={{ m: 1 }} />}
                    checked={formik.getFieldProps('cookingTimeStatus').value}
                    label={
                      formik.getFieldProps('cookingTimeStatus').value
                        ? 'Habilitado'
                        : 'Desabilitado'
                    }
                    {...formik.getFieldProps('cookingTimeStatus')}
                  />
                </FormControl>
                <FormPartialDiv>
                  <FormlLabelPartial style={{ marginRight: '6px !important' }}>
                    Tempo:
                  </FormlLabelPartial>
                  <TextField
                    style={{ width: 100, marginBottom: 3 }}
                    InputProps={{ inputProps: { min: 0 } }}
                    required
                    disabled={!formik.getFieldProps('cookingTimeStatus').value}
                    variant="outlined"
                    placeholder="Ex: 10"
                    size="small"
                    type="number"
                    {...formik.getFieldProps('cookingTimeValue')}
                  />
                </FormPartialDiv>
              </FormContainer>

              <FormContainer removeMarginBottom>
                <FormControl>
                  <FormLabel>Frete grátis</FormLabel>
                  <FormLabelControl
                    style={{ marginLeft: 8 }}
                    control={<IOSSwitch sx={{ m: 1 }} />}
                    checked={formik.getFieldProps('freeDeliveryStatus').value}
                    label={
                      formik.getFieldProps('freeDeliveryStatus').value
                        ? 'Habilitado'
                        : 'Desabilitado'
                    }
                    {...formik.getFieldProps('freeDeliveryStatus')}
                  />
                </FormControl>
                <FormPartialDiv>
                  <FormlLabelPartial style={{ marginRight: '6px !important' }}>
                    Distância máxima (km):
                  </FormlLabelPartial>
                  <TextField
                    style={{ width: 100, marginBottom: 3 }}
                    InputProps={{ inputProps: { min: 0 } }}
                    required
                    disabled={!formik.getFieldProps('freeDeliveryStatus').value}
                    variant="outlined"
                    placeholder="Ex: 10"
                    size="small"
                    type="number"
                    {...formik.getFieldProps('freeDeliveryMaxDistance')}
                  />
                </FormPartialDiv>
                <FormPartialDiv>
                  <FormlLabelPartial style={{ marginRight: '6px !important' }}>
                    Pedido mínimo (R$):
                  </FormlLabelPartial>
                  <TextField
                    style={{ width: 100, marginBottom: 3 }}
                    InputProps={{ inputProps: { min: 0 } }}
                    required
                    disabled={!formik.getFieldProps('freeDeliveryStatus').value}
                    variant="outlined"
                    placeholder="Ex: 10"
                    size="small"
                    type="number"
                    {...formik.getFieldProps('freeDeliveryMinValue')}
                  />
                </FormPartialDiv>
              </FormContainer>
              <Box
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  marginTop: '24px',
                }}
              >
                <Button style={{ width: '125px' }} onClick={() => formik.submitForm()}>
                  Editar
                </Button>
              </Box>
            </form>
          </Card>

          <Card>
            <SubTitle>Tipo de entrega</SubTitle>

            <form style={{ marginTop: 16 }} width="100%">
              <FormControl fullWidth style={{ marginBottom: 16 }}>
                <TextField
                  required
                  variant="outlined"
                  placeholder="Ex: 10"
                  size="small"
                  type="number"
                  fullWidth
                  select
                  {...formik.getFieldProps('deliveryType')}
                >
                  <MenuItem value="default$" disabled>
                    Selecione o tipo da entrega
                  </MenuItem>
                  {selectDeliveryTypeList.map((item, index) => (
                    <MenuItem key={index} value={item.value}>
                      {item.label}
                    </MenuItem>
                  ))}
                </TextField>
              </FormControl>

              {selectedDeliveryTypeAvailable ? (
                <></>
              ) : (
                <UnavailableDeliveryTypeMessage>
                  Para realizar alterações neste modo, utilize o Portal Administrativo. O tipo de
                  entrega selecionado não está disponível no momento.
                </UnavailableDeliveryTypeMessage>
              )}

              {getDeliveryComponent()}
              <Box
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  marginTop: '24px',
                }}
              >
                <Button
                  style={{ width: '125px' }}
                  disabled={!saveState}
                  onClick={() => postStoreConfigs(initialValues)}
                >
                  Salvar
                </Button>
              </Box>
            </form>
          </Card>
        </Col1>
      </Wrapper>
    </>
  );
};
